import { Page } from '@shopify/polaris';
import { useState, useEffect, useRef } from 'react';
import { withRouter } from 'react-router';
import './index.scss';
import Langauge from '../../i18n/Language';
import { store } from '../../redux/store';
const t = Langauge;

const TabsPublicBlock = (props) => {
    const {
        location,
    } = props;

    const isShopify = window.shopify;

    // tab数组
    const TabsContanier = {
        "Speed Optimization": [
            {
                id: 'sp_1',
                title: t("Site Speed Up"),
                url: "/speedOpt/site-speedup"
            },
            {
                id: 'sp_2',
                title: t("Image Optimization"),
                url: "/speedOpt/PageSpeed"
            },
            {
                id: 'sp_3',
                title: t("AMP"),
                url: "/speedOpt/seo-ant-amp"
            }
        ],
        "Search Appearance": [
            {
                id: 'alt_1',
                title: t("Image alt text"),
                url: "/searchAppearance/image-alt-text"
            },
            {
                id: 'sa_2',
                title: t("Bulk-edit Meta Tags"),
                url: "/searchAppearance/bulk-edit/manual-bulk-edit"
            },
            {
                id: 'sa_3',
                title: t("Google Structured Data"),
                url: "/searchAppearance/structured-data"
            },
            {
                id: 'sa_4',
                title: t("Local Business"),
                url: "/searchAppearance/local-business"
            },
            {
                id: 'sa_5',
                title: t("Instant Index"),
                url: "/searchAppearance/instant-index"
            },
            {
                id: 'sa_6',
                title: t("Google Analytics"),
                url: "/searchAppearance/GoogleSearchConsoleV2"
            }
        ],
        "Link Management": [
            {
                id: 'lm_1',
                title: t("Broken Links"),
                url: "/backlinks/broken-link/view-errors"
            },
            {
                id: 'lm_2',
                title: t("Exchange Backlink"),
                url: "/backlinks/exchange-backlink"
            },
            {
                id: 'lm_3',
                title: t("Backlink Audit"),
                url: "/backlinks/backlink-audit"
            },
            {
                id: 'lm_4',
                title: t("HTML Sitemap"),
                url: "/backlinks/html-sitemap"
            }
        ],
        "Keyword Research": [
            {
                id: 'kr_1',
                title: t("Keywords"),
                url: "/keywordRearch/keywords-data"
            },
            {
                id: 'kr_2',
                title: t("Keywords Explore"),
                url: "/keywordRearch/keywords-search"
            },
            {
                id: 'kr_3',
                title: t("Competitors"),
                url: "/keywordRearch/keywords-monitor"
            },
            // {
            //     id: 'kr_1',
            //     title: t("My Website Keywords"),
            //     url: "/keywordRearch/my-website-keywords"
            // },
            // {
            //     id: 'kr_2',
            //     title: t("Competitive Keyword Monitoring"),
            //     url: "/keywordRearch/keywords-monitor"
            // },
            // {
            //     id: 'kr_3',
            //     title: t("Keyword Gap"),
            //     url: "/keywordRearch/keywords-gap"
            // },
            // {
            //     id: 'kr_4',
            //     title: t("Keyword Search"),
            //     url: "/keywordRearch/keywords-search"
            // },
            // {
            //     id: 'kr_5',
            //     title: t("Keyword List"),
            //     url: "/keywordRearch/keywords-list"
            // }
        ]
    }

    const [tabIndex, setTabIndex] = useState(0);
    const [useTabsTitle, setUseTabsTitle] = useState("");
    const [TabArr, setTabArr] = useState([]);
    const [tabState, setTabState] = useState(false);
    const [indicatorStyle, setIndicatorStyle] = useState({ left: '0', width: '0' });
    const tabRefs = useRef([]);

    // 计算设置底部横条
    const updateIndicator = (index) => {
        const activeTab = tabRefs.current[index];
        if (activeTab) {
            const { offsetLeft, offsetWidth } = activeTab;
            setIndicatorStyle({
                left: `${offsetLeft === 0 ? 0 : (offsetLeft - 0.5)}px`,
                width: `${offsetWidth}px`
            });
        } else {
            requestAnimationFrame(() => updateIndicator(index));
        }
    };

    // 点击跳转
    const handleTabClick = (tab) => {
        if (!Boolean(window.savebarState)) {
            const url = location.pathname;
            if (url.indexOf(tab.url) === -1) {
                props.history.push(tab.url);
            }
        } else {
            if (isShopify) {
                isShopify.saveBar.leaveConfirmation();
            }
        }
    };

    // 设置索引和重置横条
    const setTabsStyle = (index) => {
        setTabIndex(index);
        updateIndicator(index);
    }

    // 设置横条
    const resetTabsLength = (c_url = null) => {
        // 设置公共tab
        const url = c_url || location.pathname;
        const moreUrlObj = {
            "/speedOpt": "Speed Optimization",
            "/searchAppearance": "Search Appearance",
            "/backlinks": "Link Management",
            "/keywordRearch": "Keyword Research",
        }
        const excludeObj = [
            "/speedOpt/seo-ant-amp/custome",      // amp编辑页
        ]
        const currentObj = Object.keys(moreUrlObj).find(i => url.includes(i) && !excludeObj.includes(url));
        let tag = currentObj ? moreUrlObj[currentObj] : "";
        setTabState(Boolean(currentObj));
        setUseTabsTitle(tag);   // 设置主标题
        let useTabsArr = tag ? TabsContanier[tag] : [];
        setTabArr(useTabsArr);
        if (useTabsArr.length > 0) {
            useTabsArr.forEach((item, index) => {
                if (Object.keys(moreUrlObj).includes(url)) {
                    setTimeout(() => {
                        setTabsStyle(0);
                    }, 0)
                } else if (item.url === url) {
                    setTabsStyle(index);
                } else {}
            })
        } else {
            setTabsStyle(0);
        }
    }

    useEffect(() => {
        resetTabsLength();
        store.subscribe(() => {
            resetTabsLength(window.location.pathname);
        })
    }, [location.pathname]);


    // 最终内容
    const tabContent = !tabState ? null : <Page
        title={useTabsTitle ? t(useTabsTitle) : null}
    >
        <div className="tabs-container">
            <div className="tabs-header">
                {TabArr.map((tab, index) => (
                    <div
                        key={tab.id}
                        ref={(el) => (tabRefs.current[index] = el)}
                        className={`tab ${tabIndex === index ? 'active' : ''}`}
                        onClick={() => handleTabClick(tab)}
                        style={{
                            padding: '12px 24px',
                            cursor: 'pointer',
                            userSelect: 'none',
                            color: tabIndex === index ? '#303030' : '#4A4A4A',
                            fontWeight: 550,
                            fontSize: 13
                        }}
                    >
                        {t(tab.title)}
                    </div>
                ))}
            </div>
            <div className="tab-indicator" style={{ ...indicatorStyle }}></div>
        </div>
    </Page>

    return tabContent;
};

export default withRouter(TabsPublicBlock);